import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export function NotAuthorizedPage() {
  const { user, logout } = useAuth();

  // TELLER's only surface in this app is `/pos/*` (§10) — as of the pos-pwa merge, a
  // TELLER hitting any other guarded route (a stale bookmark, a typed URL) goes straight
  // to the till instead of landing on a dead-end page they have no use for.
  if (user?.role === "TELLER") return <Navigate to="/pos/till" replace />;

  return (
    <div className="page">
      <h1 className="page__title">Not authorized</h1>
      <p>Your role ({user?.role ?? "unknown"}) doesn't have access to this page.</p>
      <button type="button" className="sl-button sl-button--secondary sl-button--md" onClick={() => void logout()}>
        Sign out
      </button>
    </div>
  );
}
